export default {
    ExcutionObject: 0, // Đối tượng phải thi hành án
    ExcutedObject: 1, // Đối tượng được thi hành án
    Bailiffs: 2, // Chấp hành viên
    PeopleCommitee: 3, // Uỷ ban nhân dân
    Supplier: 4, // Nhà cung cấp
    ObjectDifferent: 5, // Đối tượng khác
    ExcutionPeople: 6, // ĐT được THA, ĐT phải THA
};  